import { render, staticRenderFns } from "./VLocations.vue?vue&type=template&id=05f16750&"
import script from "./VLocations.vue?vue&type=script&lang=js&"
export * from "./VLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f16750')) {
      api.createRecord('05f16750', component.options)
    } else {
      api.reload('05f16750', component.options)
    }
    module.hot.accept("./VLocations.vue?vue&type=template&id=05f16750&", function () {
      api.rerender('05f16750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VLocations/VLocations.vue"
export default component.exports